import {
  backgroundImage,
  backgroundImageContainer,
  backgroundImageText,
  blackColor,
  container,
  description,
  hexToRgb,
  section,
  sectionDark,
  textCenter,
  title,
  whiteColor
} from "assets/jss/material-kit-pro-react.jsx"

const eventInfoStyle = {
  backgroundImage: {
    ...backgroundImage,
    height: "500px",
  },
  backgroundImageText,
  container,
  eventInfoButton: {
    margin: "1rem",
  },
  eventInfoDescription: {
    ...description,
    color: whiteColor,
  },
  eventInfoItem: {
    ...textCenter,
    "@media (max-width: 599px) and (orientation: landscape)": {
      flexGrow: "0",
      maxWidth: "83.333333%",
      flexBasis: "83.333333%",
    },
    "@media (max-width: 800px) and (orientation: landscape)": {
      flexGrow: "0",
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  eventInfoTitle: {
    ...title,
    color: whiteColor,
    marginTop: "0px",
  },
  section: {
    ...section,
    ...sectionDark,
    ...backgroundImageContainer,
    position: "relative",
    "&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''",
      backgroundColor: "rgba(" + hexToRgb(blackColor) + ", 0.7)",
    },
  },
}

export default eventInfoStyle
